<template>
  <div class="sidebar" :data-color="backgroundColor">
    <div class="logo">
      <router-link to="/mypage/edit/account">
        <el-tooltip content="개인정보수정" placement="top">
          <a href="#" class="simple-text logo-mini">
            <i class="jipvio-ui-icons-user_cog" style="font-size: 1.5em;"></i>
            <!-- <div class="logo-image">
              <img :src="logo" /> 
            </div> -->
          </a>
        </el-tooltip>
      </router-link>

      <a class="simple-text logo-normal">
        {{ title }}
      </a>
      <div class="navbar-minimize">
        <button
          id="minimizeSidebar"
          class="btn btn-outline-white btn-icon btn-round"
          @click="minimizeSidebar"
        >
          <i
            class="now-ui-icons text_align-center visible-on-sidebar-regular"
          ></i>
          <i
            class="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini"
          ></i>
        </button>
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import { Tooltip } from "element-ui";

export default {
  bodyClass: "sidebar-mini",
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "마이페이지"
    },
    //sidebar-and-main-panel.scss에 정의되어 있음!
    backgroundColor: {
      type: String,
      default: "jipvio-main-color",
      validator: value => {
        let acceptedValues = [
          "jipvio-main-color",
          "yellow",
          "blue",
          "green",
          "orange",
          "red",
          "black"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },

    logo: {
      type: String,
      default: "img/icon-vue.png"
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  components: {
    [Tooltip.name]: Tooltip
  },

  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
